// eslint-disable-next-line no-useless-escape
export var isPhone = function isPhone(val) {
  return /^(\+7)?[\s\-]?\(?[9][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/.test(val);
};
export var minLength = function minLength(length) {
  return function (val) {
    return !!val && val.length >= length;
  };
};
export var hasDigitAndLetter = function hasDigitAndLetter(val) {
  return !!val && /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/.test(val);
};
export var onlyDigitsAndLetters = function onlyDigitsAndLetters(val) {
  return !!val && /^[a-zA-Z0-9]+$/.test(val);
};